import ConfigModel from "./ConfigModel";
import UserModel from "./UserModel";

export default class CouponModel {
    configModel
    userModel
    constructor() {
        this.configModel = new ConfigModel()
        this.userModel = new UserModel()
    }

    async GetOffers() {
        let url = `${this.configModel.api}get_offers`
        let data = {
            access_key: "8525"
        }
        let userData = this.userModel.GetUserFromLocal()
        let authorization = userData.data.api_token

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authorization}`,
                },
                body: JSON.stringify(data)
            })

            const response_data = await response.json()
            if (!response_data.error) {
                return response_data.data
            } else {
                return []
            }
        } catch (err) {
            console.error("post request failed ", err)
            return err
        }
    }

    async GetGeneratedCoupons() {
        let url = `${this.configModel.api}get_user_coupons`
        let data = {
            access_key: "8525"
        }
        let userData = this.userModel.GetUserFromLocal()
        let authorization = userData.data.api_token

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authorization}`,
                },
                body: JSON.stringify(data)
            })

            const response_data = await response.json()
            if (!response_data.error) {
                return response_data.data
            } else {
                return []
            }
        } catch (err) {
            console.error("post request failed ", err)
            return err
        }
    }

    async GenerateCoupon(offerId) {
        let url = `${this.configModel.api}get_coupon_code`
        let data = {
            access_key: "8525",
            offer_id: offerId,
        }
        let userData = this.userModel.GetUserFromLocal()
        let authorization = userData.data.api_token

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authorization}`,
                },
                body: JSON.stringify(data)
            })

            const response_data = await response.json()
            if (!response_data.error) {
                return response_data.data
            } else {
                return []
            }
        } catch (err) {
            console.error("post request failed ", err)
            return err
        }
    }

}